// ---------------------------------------------------------------------------
// best-software.content.ts — Aggregator for BestSoftwareRanking translations
// ---------------------------------------------------------------------------
import type { SupportedLocale } from '../i18n.config';

export interface BestSoftwareText {
  heroTitle: string;
  heroSubtitle: string;
  rankings: {
    bestFor: string;
    highlights: string[];
  }[];
  evaluationCriteria: { name: string; description: string }[];
  faqItems: { question: string; answer: string }[];
}

import { BEST_SOFTWARE_AR } from './best-software.ar';
import { BEST_SOFTWARE_TH } from './best-software.th';
import { BEST_SOFTWARE_ES } from './best-software.es';
import { BEST_SOFTWARE_FR } from './best-software.fr';
import { BEST_SOFTWARE_DE } from './best-software.de';
import { BEST_SOFTWARE_JA } from './best-software.ja';
import { BEST_SOFTWARE_ZH } from './best-software.zh';
import { BEST_SOFTWARE_HI } from './best-software.hi';

export const BEST_SOFTWARE_TRANSLATIONS: Partial<Record<SupportedLocale, BestSoftwareText>> = {
  ar: BEST_SOFTWARE_AR,
  th: BEST_SOFTWARE_TH,
  es: BEST_SOFTWARE_ES,
  fr: BEST_SOFTWARE_FR,
  de: BEST_SOFTWARE_DE,
  ja: BEST_SOFTWARE_JA,
  zh: BEST_SOFTWARE_ZH,
  hi: BEST_SOFTWARE_HI,
};
